<template>
  <v-sheet
    >
    <v-expand-transition>
      <v-sheet
        v-if="isexpand"
        @click = "isexpand = !isexpand"
        color="light-blue lighten-3"
        height="150"
        dark
        class="pa-4"
        tile>
        <div v-html="brand_sel[$store.state.lang+'_content']"></div>
      </v-sheet>
    </v-expand-transition>
<!--    <v-slide-group
      v-model="model"
      class="pa-2"
      center-active
      show-arrows>
      <v-slide-item
        v-for="i in brandlist"
        :key="i.id"
        v-slot:default="{ active, toggle }">
        <v-card
          :color="active ? 'green' : 'white'"
          class="ma-2 d-flex align-center"
          height="120"
          width="150"
          @click="toggle">
          <v-img contain width="100" :src="i.thumbnail">
            <v-row
              class="fill-height"
              align="center"
              justify="center">
              <v-scale-transition>
              </v-scale-transition>
            </v-row>
          </v-img>
        </v-card>
      </v-slide-item>
    </v-slide-group> -->
    <Imgslider :imglist="brandlist" @sel="selbrand"></Imgslider>
    
  </v-sheet>
</template>

<script>
import Imgslider from '@/components/Imgslider.vue'

export default {
  components:{
    Imgslider,
  },
  data(){
    return {
      model: null,
      brandswall_io_api:'brandswall/io/',
      brandlist:[
          {
            'cn_name':'a',
            'en_name':'a',
            'thumbnail':''
          },
      ],
      isexpand:false,
      brand_sel:{},
      limit:20,
    }
  },
  methods:{
    selbrand(v){
      this.brand_sel = v;
      this.isexpand = true;
    },
    fetch(){
      let postdata = {};
      postdata.limit = this.limit;
      this.$axios.post(this.$store.state.baseurl + this.brandswall_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.brandlist = response.data.data;
              }
            }
          )
          .catch(function (e){})
    },
  },
  mounted(){
    this.fetch();
  },
}
</script>